module.exports = __webpack_public_path__ + "img/SORC.661cc4f7.png";